import * as actions from './NetWorthDonutChartActions'
import { RESET_STATE } from '../NetWorthReport/NetWorthReportActions';

const initialState = {}

const NetWorthDonutChart = (state = initialState, action) => {
    switch (action.type) {
        case actions.RECEIVE_DATA:
            let local_data = Object.assign({}, action.resp_data, {
                NetTotalInRed: action.resp_data.NetTotalInRed,
                clientId: action.clientId
            })
            if (!action.chart_type) {
                return Object.assign({}, state, {
                    [action.clientId]: {
                        ...state[action.clientId],
                        Assets: {
                            resp_data: local_data,
                            is_initialized: true,
                            chart: action.resp_data.ChartData.AssetsChart
                        },
                        Liabilities: {
                            resp_data: local_data,
                            is_initialized: true,
                            chart: action.resp_data.ChartData.LiabilitiesChart
                        }
                    }
                })
            }
            return Object.assign({}, state, {
                [action.clientId]: {
                    ...state[action.clientId],
                    [action.chart_type]: {
                        resp_data: local_data,
                        is_initialized: true,
                        chart: action.resp_data.ChartData[`${action.chart_type}Chart`]
                    }
                }
            })
            case RESET_STATE:
              return initialState;
        default:
            return state
    }
}

export default NetWorthDonutChart